import img1 from '../../img/products/prod1.png';
import img2 from '../../img/products/prod2.png';
import img3 from '../../img/products/prod3.png';
import img4 from '../../img/products/prod4.png';
import img5 from '../../img/products/prod5.png';
import img6 from '../../img/products/prod6.png';
import img7 from '../../img/products/prod7.png';
import img8 from '../../img/products/prod8.png';
import img9 from '../../img/products/prod9.png';
import img10 from '../../img/products/prod10.png';
import img11 from '../../img/products/prod11.png';


const mockProducts = [
    {
      id: 1,
      title: "STABI BRACKET",
      imageUrl: img1,  // Use imported image without quotes
    },
    {
      id: 2,
      title: "DIRT SHIELD CAPS",
      imageUrl: img2,  // Placeholder image
    },
    {
      id: 3,
      title: "BRAKE HOSE BRACKETS",
      imageUrl: img3,  // Placeholder image
    },
    {
        id: 4,
        title: "ABS BRACKET",
        imageUrl: img4,  // Use imported image without quotes
      },
      {
        id: 5,
        title: "BASE CUPS",
        imageUrl: img5,  // Placeholder image
      },
      {
        id: 6,
        title: "SPRING SEAT",
        imageUrl: img6,  // Use imported image without quotes
      },
      {
        id: 7,
        title: "PISTON ROD - SPRING SEATS",
        imageUrl: img7,  // Placeholder image
      },
      {
        id: 8,
        title: "RETAINERS",
        imageUrl: img8,  // Use imported image without quotes
      },
      {
        id: 9,
        title: "BUMPER CAPS",
        imageUrl: img9,  // Placeholder image
      },
    {
      id: 10,
      title: "LOOP / I RING / STOPPER RING",
      imageUrl: img10,  // Placeholder image
    },
    {
      id: 11,
      title: "BASE PLATES",
      imageUrl: img11,  // Placeholder image
    },
];

export default mockProducts;
